import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import DiscountBanner from '../components/DiscountBanner';
import ReviewBanner from '../components/ReviewBanner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogListPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/blog/posts`);
        if (!cancelled) setPosts(res.data);
      } catch (err) {
        if (!cancelled) setError('We couldn\'t load the blog right now. Please try again shortly.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch {
      return iso;
    }
  };

  return (
    <div className="blog-page" data-testid="blog-list-page">
      <DiscountBanner size="large" />
      <ReviewBanner />

      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Cat Care Blog</h1>
          <p className="page-subtitle">Tips, advice and stories from our visits across Walsall</p>
        </div>
      </section>

      <section className="blog-section">
        <div className="container">
          {loading && <p className="blog-status" data-testid="blog-loading">Loading posts…</p>}
          {error && <p className="blog-status blog-error" data-testid="blog-error">{error}</p>}
          {!loading && !error && posts.length === 0 && (
            <p className="blog-status" data-testid="blog-empty">No posts published yet — check back soon!</p>
          )}

          <div className="blog-grid" data-testid="blog-grid">
            {posts.map((post) => (
              <article key={post.slug} className="blog-card" data-testid={`blog-card-${post.slug}`}>
                <Link to={`/blog/${post.slug}`} className="blog-card-image-link">
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    className="blog-card-image"
                    loading="lazy"
                  />
                </Link>
                <div className="blog-card-body">
                  <span className="blog-card-category">{post.category}</span>
                  <h2 className="blog-card-title">
                    <Link to={`/blog/${post.slug}`} data-testid={`blog-link-${post.slug}`}>
                      {post.title}
                    </Link>
                  </h2>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <div className="blog-card-meta">
                    <span>{formatDate(post.publishedAt)}</span>
                    <span aria-hidden="true">•</span>
                    <span>{post.readTime}</span>
                  </div>
                  <Link to={`/blog/${post.slug}`} className="blog-card-readmore">
                    Read more →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogListPage;
